<script lang="ts">
    class OrarioLavoro {
        orarioInDa: string = '00:00';
        orarioInA: string = '00:00';
        orarioOutDa: string = '00:00';
        orarioOutA: string = '00:00';
        altriOrari: string = '';
        gestioneOreStraordinarie: string = '';
        sabatoLavorativo: boolean = undefined;
        domenicaLavorativo: boolean = undefined;

        constructor(init?: OrarioLavoro) {
            Object.assign(this, init);
        }
    }

    export let data: OrarioLavoro = new OrarioLavoro();

    function isAnyFieldSet(): boolean {
            return (data?.orarioInDa !== '00:00' && data?.orarioInDa?.trim() !== '' ||
                    data?.orarioInA !== '00:00' && data?.orarioInA?.trim() !== '' ||
                    data?.orarioOutDa !== '00:00' && data?.orarioOutDa?.trim() !== '' ||
                    data?.orarioOutA !== '00:00' && data?.orarioOutA?.trim() !== '' ||
                    data?.altriOrari?.trim() !== '' ||
                    data.gestioneOreStraordinarie?.trim() !== '',
                    data?.sabatoLavorativo !== undefined ||
                    data?.domenicaLavorativo !== undefined) && data !== null
        }
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="text-center border border-black">Orario di ingresso dei dipendenti</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{(data?.orarioInDa || '--:--') + ' - ' + (data?.orarioInA || '--:--')}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Orario di uscita dei dipendenti</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{(data?.orarioOutDa || '--:--') + ' - ' + (data?.orarioOutA || '--:--')}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Altri orari</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{(data?.altriOrari || '-')}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Come vengono gestite le ore straordinarie?</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{(data?.gestioneOreStraordinarie || '-')}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Sabato lavorativo</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.sabatoLavorativo !== undefined ? (data?.sabatoLavorativo ? "Sì" : "No") : '-'}
            </td>
        </tr>
        <tr>
            <td class="text-center border border-black">Domenica lavorativa</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.domenicaLavorativo !== undefined ? (data?.domenicaLavorativo ? "Sì" : "No") : '-'}
            </td>
        </tr>
    </tbody>
</table>
